
import { useState, useEffect } from "react"
import Aside from "../components/aside/Aside"
import HeaderPage from "../components/header/HeaderPage"
import {Outlet} from "react-router-dom"
import {CustomProvider} from "rsuite";

//////////////////// COMPONENTE //////////////////////
export default function Core() {

    const [theme, setTheme] = useState(localStorage.getItem('theme') ? JSON.parse(localStorage.getItem('theme')) : 'light');
    const body = document.body;
    const [navSm, setNavSm] = useState(false);

    //////////////////// Cambiar tema de los componentes ////////////////////
    function handleChangeTheme(theme){
        localStorage.setItem('theme', JSON.stringify(theme));

        if(theme === 'light' || theme === 'dark') {
            body.setAttribute("data-bs-theme", `${theme}`)
            setTheme(`${theme}`)
        }else {
            body.setAttribute("data-bs-theme", (window.matchMedia('(prefers-color-scheme: dark)').matches ? "dark" : "light"))
            setTheme(window.matchMedia('(prefers-color-scheme: dark)').matches ? "dark" : "light");
        }
    }

    //////////////////// ScrollY ////////////////////
    const [scrollB, setScrollB] = useState(false);
    useEffect(() => {
        let scrollPos = 0;

        function saberScroll(){
            let st = window.scrollY || document.documentElement.scrollTop; // Detecta scroll vertical
            // Sí se hace scroll aparece boton scrollTop
            if (st > scrollPos){
                setScrollB(true);
            }
            scrollPos = st; // Actualiza la posición anterior
        }

        window.addEventListener('scroll',  saberScroll);

        return () => { window.removeEventListener('scroll', saberScroll) }

    }, []);

    function scrollTop(){
        window.scrollTo({top: 0, behavior: 'smooth'});
    }

    return (
        <>
            <style type={'text/css'}>
                {`
                    .scrolltop {
                     opacity: var(--bs-scrolltop-opacity-on);
                    }
                    
                    .scrolltop:hover {
                        opacity: var(--bs-scrolltop-opacity-hover);
                        transition: color .2s ease;
                    }
                `}
            </style>
            <div className='d-flex flex-column flex-root' data-bs-theme={theme}>
                <div className='page d-flex flex-row flex-column-fluid'>
                    <Aside navSm={navSm} setNavSm={setNavSm}/>
                    <div className='wrapper d-flex flex-column flex-row-fluid' id={'wrapper'}>
                        <HeaderPage
                            handleChangeTheme={handleChangeTheme}
                            setNavSm={setNavSm}
                        />
                        <CustomProvider theme={theme}>
                            <Outlet/>
                        </CustomProvider>
                    </div>
                </div>
            </div>
            {
                scrollB && <div className="d-flex scrolltop" onClick={scrollTop}>
                                <i className="ki-duotone ki-arrow-up">
                                    <span className="path1"></span>
                                    <span className="path2"></span></i>
                            </div>
            }
            {
                 navSm && <div style={{zIndex: 9}} className="drawer-overlay"></div> // El fondo pierde enfoque
            }
        </>
    )
}
